export default __webpack_public_path__ + "img/ZUaCzWXN.cd7c6d90.svg";